<app-custom-dialog
    header="Select fields to run report"
    [(visible)]="visible"
    (visibleChange)="onVisibleChange($event)">
    <div content class="py-1">
        <p-checkbox
            [binary]="true"
            class="w-full mb-4"
            [label]="'All'"
            [(ngModel)]="localIsAllSelected"
            (onChange)="onToggleAll()"></p-checkbox>
        <div class="grid grid-cols-2 gap-4">
            @for(item of localData; track $index) {
                <p-checkbox
                    [binary]="true"
                    [label]="item.label"
                    [(ngModel)]="item.isSelected"
                    [disabled]="isRequiredField(item)"
                    (onChange)="onItemChanged()">
                </p-checkbox>
            }
        </div>
        
    </div>
  <div footer class="flex flex-row justify-between items-center">
    <span>{{ exportSelectedFieldsText }}</span>
    <div class="flex flex-row gap-3">
    <app-button
        [variant]="'outline-secondary'"
        [label]="'action.cancel' | translate"
        size="xl"
        (onClick)="onVisibleChange(false)"></app-button>
    <app-button
        [label]="'action.save' | translate"
        size="xl"
        (onClick)="onSave()"></app-button>
    </div>
  </div>
</app-custom-dialog>